/**
 * Toggle hidden on form group
 * ======================================
 * - jquery needed
 * - toggle required attribute in group as well
 */

import $ from "jquery";

$(".ajaxForm").on("change", ".js-formToggle", function(e) {
	const $this = $(this);
	const $group = $("#" + $this.attr("data-target"));
	const $required = $group.find("input[toggle-required]");

	if (typeof $group.attr("hidden") === "undefined") {
		$group.attr("hidden", "hidden");
		$required.removeAttr("required");
	} else {
		$group.removeAttr("hidden");
		$required.attr("required", "required");
	}
});
